var exports = {
  "iE": "xaee3c4fa--2c80a3--wrapper",
  "DD": "xaee3c4fa--2c80a3--title",
  "r_": "xaee3c4fa--2c80a3--list-wrapper",
  "Qn": "xaee3c4fa--2c80a3--item-wrapper",
  "nf": "xaee3c4fa--2c80a3--link",
};

module.exports = exports;
